import './Switch.css';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTimesCircle,
    faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';

const BtxSwitch = (props) => {
    const {
        value = false,
        label = '',
        title = '',
        onChange = () => {},
        disabled = false,
        labelClass = 'text-light',
        labelStyle = {},
        className = '',
    } = props;

    return (
        <table className={`switch-table ${className}`}>
            <tbody>
                <tr className="no-border">
                    <td className="switch-col-sm unselectable">
                        <div
                            className={`switch d-inline-block ${
                                disabled
                                    ? `opacity-2`
                                    : `switch-active hoverable`
                            } ${
                                value
                                    ? `bg-success text-right`
                                    : `bg-secondary text-left`
                            }`}
                            title ={title}
                            onClick={() => (disabled ? `` : onChange())}>
                            <div
                                className={`switch-side text-center text-light ${
                                    value ? `switch-on` : `switch-off`
                                }`}>
                                <FontAwesomeIcon
                                    icon={value ? faCheckCircle : faTimesCircle}
                                    size="lg"
                                />
                            </div>
                        </div>
                    </td>
                    {label !== '' && (
                        <td
                            className={`switch-col switch-col-lg text-left ${labelClass}`}
                            style={labelStyle}>
                            {label}
                        </td>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default BtxSwitch;
